import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "category-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "search"
};
const _hoisted_4 = {
  class: "artice-list"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
import { reactive, ref, markRaw } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getArticeListApi } from '@/service/modules/artice';
import { addLoading } from '@/utils/element-method';
import { getAllTagListApi, deleteArticeApi } from '@/service/modules/artice';
import { ElMessage, ElMessageBox } from 'element-plus';
import { QuestionFilled } from '@element-plus/icons-vue';
import protoPagination from '@/components/proto-pagination.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const tagList = ref([]);
    const page = reactive({
      current: 1,
      size: 10
    });
    const articeList = ref([]);
    const total = ref(0);
    const form = reactive({
      type: '',
      values: []
    });
    getAllTagList();
    async function getAllTagList() {
      try {
        let res = await getAllTagListApi();
        tagList.value = JSON.parse(res.data[0].category);
      } catch {}
    }
    getArticeList();
    async function getArticeList() {
      const instance = addLoading('.artice-list');
      const query = form.type ? form.type === 'index' ? {
        tag: 'index'
      } : {
        tag: form.values?.length ? form.values[form.values?.length - 1] : form.type
      } : {};
      try {
        const res = await getArticeListApi({
          ...page,
          ...query
        });
        articeList.value = res.data?.articles || [];
        total.value = res.data?.total || 0;
      } catch (error) {
        console.error('获取文章列表失败:', error);
      } finally {
        instance.close();
      }
    }
    function handleArticeTableCurrentChange(val) {
      page.current = val;
      getArticeList();
    }
    function handleCategoryChange() {
      restData();
    }
    function restData() {
      page.current = 1;
      getArticeList();
    }
    function handleTypeChange(val) {
      if (val === 'index') {
        // restData()
        form.values = [];
      }
      restData();
    }
    function handleClearTypeChange() {
      form.values = [];
      restData();
    }
    function handleUpdate(id) {
      router.push({
        path: '/article/add',
        query: {
          id
        }
      });
    }
    function handleDeleteActice(id) {
      ElMessageBox.confirm('此操作将永久删除该数据, 是否继续？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          let res = await deleteArticeApi(id);
          ElMessage.success('删除成功');
          restData();
        } catch {}
      }).catch(() => {});
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createTextVNode("文章列表 ")), _createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/article/add')),
        type: "primary",
        style: {
          "margin-left": "5px"
        }
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("新增")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
        inline: true,
        "label-position": "left",
        "label-width": "70px",
        ref: "formRef",
        model: form
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "文章类型"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.type = $event),
            clearable: "",
            onChange: handleTypeChange,
            onClear: handleClearTypeChange,
            placeholder: "请选择文章类型",
            style: {
              "width": "200px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "养生知识",
              value: "index"
            }), _createVNode(_component_el_option, {
              label: "康养教育",
              value: "kangyang"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _withDirectives(_createVNode(_component_el_form_item, {
          label: "文章分类"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_cascader, {
            style: {
              "width": "300px"
            },
            modelValue: form.values,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.values = $event),
            options: tagList.value,
            clearable: "",
            onClear: handleClearTypeChange,
            onChange: handleCategoryChange,
            props: {
              expandTrigger: 'click',
              label: 'name',
              value: 'key'
            },
            placeholder: "请选择分类"
          }, null, 8, ["modelValue", "options"])]),
          _: 1
        }, 512), [[_vShow, form.type === 'kangyang']])]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
        data: articeList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        empty: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("div", {
          class: "table-empty"
        }, [_createElementVNode("img", {
          class: "no-data",
          src: _imports_0,
          alt: ""
        }), _createElementVNode("div", {
          class: "empty-text"
        }, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          width: "70"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (page.current - 1) * page.size), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "title",
          label: "标题",
          "show-overflow-tooltip": "",
          width: "500"
        }), _createVNode(_component_el_table_column, {
          prop: "title",
          label: "文章类型"
        }, {
          default: _withCtx(scope => [scope.row.tag_cn ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_tag, {
            type: "success"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.tag_cn), 1)]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true), !scope.row.tag_cn ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_tag, {
            type: "primary"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("养生知识")])),
            _: 1
          })])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "updateTime",
          label: "修改时间",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleUpdate(scope.row.id)
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => handleDeleteActice(scope.row.id)
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(protoPagination, {
        page: page,
        total: total.value,
        onCurrentChange: handleArticeTableCurrentChange
      }, null, 8, ["page", "total"])])]);
    };
  }
});